import React, { useMemo } from 'react';
import styles from './BookPropertyButton.module.scss';
import { PROPERTY_BOOK_BUTTON } from '../../constans/texts/texts';
import ArrowTopRight from '../../assets/img/arrrowTopRight.svg';
import StorageService from '../../services/storage.service';
import { LOCALSTORAGE_KEYS } from '../../constans/localstorage';

function BookPropertyButton({
  details, buttonWrapperClasses,
}) {
  const { affiliateLink } = details;
  const storage = StorageService();

  const { values } = useMemo(() => storage
    .get(LOCALSTORAGE_KEYS.SEARCH), [storage]);

  let link = affiliateLink || '';

  link = link.replace(/&no_rooms=[^&]*/, '');
  link = link.replace(/&group_adults=[^&]*/, '');
  link = link.replace(/&&/g, '&');
  link = link.trim();

  if (values) {
    const {
      adultGuests, checkin, checkout, kidGuests, kids, rooms,
    } = values;

    link = `${link}
    &checkin=${encodeURIComponent(checkin)}
    &checkout=${encodeURIComponent(checkout)}
    &group_adults=${encodeURIComponent(adultGuests)}
    &no_rooms=${encodeURIComponent(rooms)}  
    &group_children=${encodeURIComponent(kidGuests)}`;

    if (kids.length > 0) {
      for (let i = 0; i < kidGuests; i++) {
        link += `&age=${encodeURIComponent(kids[i])}`;
      }
    }
  }

  return (
    <div className={buttonWrapperClasses}>
      { affiliateLink
          && (
          <div className={`flex  ${styles.link}`}>
            <a
              href={link}
              target="_blank"
              rel="noreferrer noopener"
              className="btn t-600"
            >
              {PROPERTY_BOOK_BUTTON}
            </a>

            <img src={ArrowTopRight} className={styles.arrow} alt="logo" />
          </div>
          )}
    </div>
  );
}

export default BookPropertyButton;
